import { render, staticRenderFns } from "./FormControlModulestructureType.vue?vue&type=template&id=1ba519b6"
import script from "./FormControlModulestructureType.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulestructureType.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports